// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"539": "7be9393a","818": "9fbd56ff",}[chunkId] + ".css"
}